import { ReactNode } from 'react'
import { setIdpInfo } from '../store/actions/EnsAction'
import useAuth from '../hooks/useAuth'
import { useAppDispatch } from 'hooks'
import { useQuery } from '@tanstack/react-query'
import { getIdpInfo } from 'api/queries'

const IdpValidator = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch()
  const auth = useAuth()

  useQuery({
    queryFn: getIdpInfo,
    queryKey: ['idp'],
    enabled: !auth.hasEnsActiu,
    onSuccess: (data) => {
      dispatch(setIdpInfo({ ...data }))
    },
    retry: false,
    useErrorBoundary: true
  })

  return <>{auth.hasEnsActiu && children}</>
}

export default IdpValidator
